module.exports = __webpack_public_path__ + "components/guide-page/static/best-surf-background-e30f046322e0d45d08eee08a791bd68c.jpg";